import React, { useEffect, useState } from "react";
import "./Styles.css";
import Axios from "../../../api/axios/Axios";
import { RiBookOpenLine } from "react-icons/ri";

const RugbyVicU16s2025Recap = () => {
  document.title = "Katch | Blog";

  const [views, setViews] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  const apiGetViewCount = () => {
    Axios.get("/api/v1/blog/views", { params: { blogId: 2 } })
      .then((res) => {
        const { views } = res.data;
        return setViews(views);
      })
      .catch((err) => console.error(err));
  };

  const apiUpdateViewCount = () => {
    let timer;

    const handleScroll = () => setScrolled(true);

    window.addEventListener("scroll", handleScroll);

    if (scrolled) {
      // Start 30s timer after first scroll
      timer = setTimeout(async () => {
        Axios.post("/api/v1/blog/views", {
          blogId: 2,
        })
          .then((res) => {
            const { views } = res.data;
            setViews(views);
          })
          .catch((err) => console.error(err));
      }, 3000);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timer);
    };
  };

  useEffect(() => {
    apiGetViewCount();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => apiUpdateViewCount(), [scrolled]);

  return (
    <main className="article-container">
      {/* Team Hero Section */}
      <section className="team-photo-section">
        <h1 className="article-title">Rugby Victoria U16s 2025 Recap</h1>
        <p className="article-subtitle">
          Grit, Growth and a Season to Remember
        </p>

        <div className="blog-meta">
          <span>By Katch Sports</span>
          <span>•</span>
          <time dateTime={new Date().toISOString()}>October 28, 2025</time>
          <span style={{ alignItems: "center" }}>
            <RiBookOpenLine style={{ marginRight: "0.2rem" }} />
            {views}
          </span>
        </div>

        <br />

        <img
          src="https://d337v8ouw0jp30.cloudfront.net/rugby-victoria-u16s-2025-recap.jpg"
          alt="Rugby Victoria U16s 2025 Team"
          className="team-photo"
        />
      </section>

      {/* Article Body */}
      <article className="article-body">
        <section>
          <p>
            Every season tells a story, and for the Rugby Victoria U16s, the
            2025 campaign was about breaking barriers, earning respect and
            setting new benchmarks.
          </p>

          <br />

          <p>
            What started as another underdog run turned into one of the most
            memorable years since Victoria joined the Super Rugby U16s
            competition. There were highs and lows, lessons and triumphs, but
            above all, there was growth.
          </p>

          <br />
          <p>
            Coming into 2025, the message was simple: compete, learn and grow.
          </p>

          <br />

          <p>
            Facing the Western Force, a team Victoria had beaten twice in
            previous years, the boys came in confident. It was a gritty,
            physical contest that swung back and forth. The scoreboard read
            19-24 at full time, a narrow loss that showed Victoria could match
            it with anyone.
          </p>

          <br />

          <p>
            Round Two brought the Queensland Reds, a side known for pace, power
            and polish. The result was tough to swallow: 68-6. But this wasn’t
            the kind of loss that breaks teams; it was one that builds
            perspective. Queensland showed the standard. Victoria took notes.
          </p>

          <br />

          <p>
            Then came the breakthrough. Against the Brumbies, Victoria played
            with energy and confidence. The forwards dominated contact, and the
            backs executed crisp, fearless plays. The result: Victoria 31 -
            Brumbies 20.
          </p>

          <br />

          <p>
            A statement win. A new benchmark. For the first time in Super Rugby,
            Rugby Victoria has beaten the Brumbies
          </p>

          <br />

          <p>
            The final clash against the Waratahs was always going to be tough.
            The scoreline, 81-7, was heavy. But within that seven points was
            something priceless, Victoria recorded their first try against the
            Waratahs, scored by Darzcy Vaiimene.
          </p>

          <br />

          <p>
            That try meant more than just points, it was proof that even against
            the best, Victoria could break through.
          </p>

          <h4>Team Achievements - Victoria</h4>
          <ul>
            <li>First win over the Brumbies</li>
            <li>First try against the Waratahs</li>
            <li>Best finish, 4th place overall</li>
            <li>
              Multiple players named in the Super Rugby U16s Team of the Week
            </li>
          </ul>

          <h4>Super Rugby Team of the Week - Victoria</h4>
          <ul className="team-of-week">
            <li>
              Ihaka Toko <span>(Wyndham City RC)</span>
            </li>
            <li>
              Kohen Tavita <span>(Wyndham City RC)</span>
            </li>
            <li>
              Eitini Samasoni <span>(Melton RC)</span>
            </li>
            <li>
              Lenix Aiga <span>(Wyndham City RC)</span>
            </li>
            <li>
              Sione Finau <span>(Melton RC)</span>
            </li>
            <li>
              Leroy Fiu <span>(Northern RC)</span>
            </li>
          </ul>

          <br />

          <p>
            Each milestone represented years of quiet work, from grassroots
            clubs to state pathways, finally paying off on the national stage.
          </p>

          <br />

          <p>
            There’s no denying the team still has ground to cover. The big
            losses against Queensland Reds and NSW Waratahs highlighted key
            areas for growth, defensive spacing, decision-making and composure
            under pressure.
          </p>

          <br />

          <p>
            But the blueprint is now in place. Future squads will build on this
            foundation, with better preparation and stronger alignment between
            schools, clubs and high-performance pathways.
          </p>

          <br />

          <p>
            The goal is clear:{" "}
            <strong>
              to not just compete, but to consistently challenge for top-three
              finishes.
            </strong>
          </p>
        </section>
      </article>

      {/* Tags */}
      <div className="tags">
        <p>
          Tags: <span>Rugby Victoria</span> <span>U16s</span>{" "}
          <span>Super Rugby</span> <span>KatchSports</span>{" "}
          <span>Grassroots</span>
        </p>
      </div>

      {/* Footer */}
      <footer className="article-footer">
        <p className="small-text">
          &copy; 2025 KatchTV Sports. All rights reserved.
        </p>
        <div className="footer-actions">
          <a href="/" className="btn-primary">
            Home
          </a>
          <a href="/support" className="btn-secondary">
            Contact
          </a>
        </div>
      </footer>
    </main>
  );
};

export default RugbyVicU16s2025Recap;
